import React from 'react';
import { useDataContext } from "../../context/datacontext";
import { Col, Row } from 'react-bootstrap';

const Player = ({pos, id}) => {
    const { mySquad } = useDataContext();

    const player = mySquad.find(player => {
        return player.id === id
    });

    return (<Row><Col>{pos}</Col><Col>{id}</Col><Col>{player ? player.fname+" "+player.lname : "unknown"}</Col></Row>)
}

export default Player